"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CompanyEntity_1 = __importDefault(require("./Entity/CompanyEntity"));
var Company = /** @class */ (function () {
    function Company(session) {
        this.companyEntity = new CompanyEntity_1.default(session);
    }
    Company.prototype.get = function (id) {
        return this.companyEntity.service.get(id);
    };
    Company.prototype.getAll = function (options) {
        return this.companyEntity.service.getAll(options);
    };
    Company.prototype.create = function (company) {
        return this.companyEntity.service.create(company);
    };
    Company.prototype.update = function (id, company) {
        return this.companyEntity.service.update(id, company);
    };
    Company.prototype.delete = function (id) {
        return this.companyEntity.service.delete(id);
    };
    Company.prototype.getUsers = function (companyId) {
        return this.companyEntity.getUsers(companyId);
    };
    return Company;
}());
exports.default = Company;
//# sourceMappingURL=Company.js.map